﻿import { JSEncrypt } from 'jsencrypt';

export function encrypt(value: string) {
    const encrypt = new JSEncrypt();
    const publicKey = (document.querySelector('#RSA_PUBLIC_KEY') as HTMLInputElement).value;
    encrypt.setPublicKey(publicKey);
    const result = encrypt.encrypt(value);
    if (result === false) {
        console.log('encrypt error:' + value, publicKey);
        return '';
    }
    return result;
}